import './App.css';
import React,{useState,useEffect} from 'react';
import NavBar from './components/NavBar';
import FlightMap from './components/FlightMap';
import Footer from './components/Footer'
import 'bootstrap/dist/css/bootstrap.min.css'; //Improtant things
import Spinner from 'react-bootstrap/Spinner';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


const basename = process.env.NODE_ENV === 'production' ? '/flymap' : '/';

function App() {

  const [popAlert, setPopAlert] = useState(true);
  const [countryCode,setCountryCode] = useState('Canada')
  const [onGround,setOnGround] = useState(false)
  const [planes,setPlanes] = useState([])
  const [isLoading, setIsLoading] = useState(false);

  const geoURL = "https://opensky-network.org/api/states/all"

  useEffect(() => {
    const fetchPlanes = async () => {
      setIsLoading(true);
      let data;
      try { //For Real API Call
        const response = await fetch(geoURL);
        data = await response.json();
        if (!response.ok || data.states == null ) throw new Error('Network response was not ok');
      } 
      catch (error) { 
        data = await import('../src/fakeplanes.json')
        data = data.default

       // 只有当popAlert为true时才显示警告，并更新状态为false
       if (popAlert) {
        alert("API Call Limited! Now using Demo Data! Please Enjoy!");
        setPopAlert(false); // 更新popAlert状态，防止再次弹出警告
      }
      } finally {
        setIsLoading(false); // 完成加载
      }

      // 确保data是定义好的，然后访问它的states属性
    if (data && data.states) {
      const filteredPlanes = data.states.filter(
        plane => plane[2] === countryCode && plane[8] === onGround && plane[5] != null && plane[6] != null
      );
      setPlanes(filteredPlanes);
    }

    };
    fetchPlanes();
  }, [countryCode, onGround, popAlert]);

  return (
    <Router basename="/">
      <Routes>
          <Route path="/" element={<div className="App">
        {isLoading && <Spinner animation="grow" className='loading-overlay'/>}
        <NavBar countryCode={countryCode} onGround={onGround}  setCountryCode={setCountryCode} setOnGround={setOnGround} />
        <FlightMap planes={planes}/>
        <Footer className="footer" />
      </div>}/>
        </Routes>
      
    </Router>
  );
}

export default App;
